import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import type { SxProps } from '@mui/material';

/**
 * משטח שורה בתפריט התבניות — מסגרת עדינה + מעבר secondary בריחוף.
 * משותף ל־`MenuSingleTemplate` ולשורת שיחה ברשימה כדי לשמור אותה שפה ויזואלית.
 */
export function templateMenuListRowSurfaceSx(theme: Theme): SxProps<Theme> {
  return {
    boxShadow: 'none',
    border: '1px solid rgba(255, 255, 255, 0.15)',
    transition: theme.transitions.create(['box-shadow', 'border-color', 'background-color'], {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeInOut,
    }),
    '&:hover': {
      borderColor: alpha(theme.palette.secondary.main, 0.45),
      boxShadow: `0 0 0 1px ${alpha(theme.palette.secondary.main, 0.25)}, 0 0 20px ${alpha(theme.palette.secondary.main, 0.18)}`,
    },
  };
}
